import { useState } from "react";
import { CoreModal, CoreModalDescription } from "../../core";
import { useMobileLayout } from "../../hooks";
import { ProctoringOptionProfileV2 } from "@verity/proctoring-option/types";
import i18nPackage from "../../i18n/i18n";
import { getProfileName } from "../profile/profileHelpers";

export const DeleteProfile = ({
	profile,
	onDelete,
	onClose,
}: {
	profile: ProctoringOptionProfileV2;
	onDelete: () => void;
	onClose: () => void;
}) => {
	const [deletedClicked, setDeleteClicked] = useState(false);
	const isMobileLayout = useMobileLayout();

	return (
		<CoreModal
			title={
				isMobileLayout
					? i18nPackage.t("editQuizPage.deleteProfileModal.titleShort")
					: i18nPackage.t("editQuizPage.deleteProfileModal.title")
			}
			open={true}
			onClose={onClose}
			minWidth={isMobileLayout ? "min(100%, 550px)" : "min(60%, 550px)"}
			widthFixed
			buttons={[
				{
					text: i18nPackage.t("editQuizPage.deleteProfileModal.cancel"),
					color: "secondary",
					onClick: onClose,
				},
				{
					text: i18nPackage.t("editQuizPage.deleteProfileModal.delete"),
					color: "cancel",
					onClick: () => {
						setDeleteClicked(true);
						onDelete();
					},
					disabled: deletedClicked,
					loading: deletedClicked,
				},
			]}
		>
			<CoreModalDescription>
				{i18nPackage.t("editQuizPage.deleteProfileModal.text", { profileName: getProfileName(profile) })}
			</CoreModalDescription>
		</CoreModal>
	);
};

export default DeleteProfile;
